import { CheckSVG, EditSVG } from "../../assets/icon/svg";

interface Props {
    isEditing: boolean;
    onEdit: () => void;
    onCancel: () => void;
    onSave: () => void;
    editLabel?: string;
    disabled?: boolean;
    isLoading?: boolean;
}

export default function EditSaveCancelButtons({ isEditing, onEdit, onCancel, onSave, editLabel = "Edit", disabled = false, isLoading = false, }: Props) {

    const isDisabled = disabled || isLoading;

    return (
        <>
            {isEditing ? (
                <button
                    type="button"
                    onClick={onEdit}
                    disabled={isDisabled}
                    className="flex h-8 items-center justify-center gap-2 rounded border border-gray-300 bg-white px-4 text-xs font-medium text-gray-700 transition hover:border-[#186cb2] hover:bg-[#eef6fc] hover:text-[#186cb2] disabled:cursor-not-allowed disabled:opacity-50"
                >
                    <EditSVG className="h-3 w-3" />
                    {editLabel}
                </button>
            ) : (
                <div className="flex shrink-0 flex-row gap-1.5 sm:gap-2">
                    <button
                        type="button"
                        disabled={isDisabled}
                        onClick={onCancel}
                        className="h-8 rounded border border-gray-300 bg-white px-4 text-xs font-medium text-gray-700 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
                    >
                        Cancel
                    </button>

                    <button
                        type="button"
                        disabled={isDisabled}
                        onClick={onSave}
                        className="flex h-8 items-center justify-center gap-2 rounded bg-[#186cb2] px-4 text-xs font-medium text-white transition hover:bg-[#145a96] disabled:cursor-not-allowed disabled:opacity-50"
                    >
                        {isLoading ? (
                            <span className="h-3 w-3 animate-spin rounded-full border-2 border-white/40 border-t-white" />
                        ) : (
                            <CheckSVG className="h-3 w-3" />
                        )}

                        {isLoading ? "Saving..." : "Save"}
                    </button>
                </div>
            )}
        </>
    );
}